class Navigator {
  constructor({ routes = [], history } = {}) {
    if (routes.length < 1) {
      throw new TypeError('Expected `routes` to contain at least one route');
    }
    this.routes = routes;
    this.history = history;
  }

  currentPage() {
    return this.history.location.pathname;
  }

  remainingPages() {
    const currentIndex = this.routes.indexOf(this.currentPage());
    return this.routes.length - 1 - currentIndex;
  }

  isLastPage() {
    const lastPage = this.routes[this.routes.length - 1];
    return this.history.location.pathname === lastPage;
  }

  nextPage() {
    if (this.isLastPage()) return;
    const nextPage = this.routes[this.routes.indexOf(this.currentPage()) + 1];
    this.history.push(nextPage);
  }
}

export default Navigator;
